<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        {{ aLang.c_list }} {{ title }}
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body">
        <div class="text-left">
          <b-collapse
            v-bind:visible="mData.tableRules.showFormSearch"
            id="myFormSearch"
          >
            <b-card>
              <el-form
                ref="myForm"
                label-position="top"
                @submit.native.prevent
                :model="mData.tableRules.dataSearch.value"
                :rules="mData.tableRules.dataSearch.valid"
              >
                <b-row>
                  <b-col md="3">
                    <el-form-item :label="aLang.sd_account_code">
                      <el-input
                        v-model="
                          mData.tableRules.dataSearch.value[
                            'du_lieu_khai_bao.user_account'
                          ]
                        "
                        clearable
                      ></el-input>
                    </el-form-item>
                  </b-col>

                  <b-col md="3">
                    <el-form-item :label="aLang.sd_safe_destination_name">
                      <el-input
                        v-model="
                          mData.tableRules.dataSearch.value[
                            'thong_tin_chung.ten'
                          ]
                        "
                        clearable
                      ></el-input>
                    </el-form-item>
                  </b-col>
                  <b-col md="3">
                    <el-form-item :label="aLang.sd_safe_destination_type">
                      <el-select
                        v-model="
                          mData.tableRules.dataSearch.value.loai_diem_den
                        "
                        :placeholder="aLang.c_select"
                        clearable
                        filterable
                      >
                        <el-option
                          v-for="item in mData.dataDefault.listLoaiDDAT"
                          :key="item.code"
                          :label="item.text"
                          :value="item.code"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </b-col>
                  <b-col md="3">
                    <el-form-item :label="aLang.sd_tax_code">
                      <el-input
                        v-model="
                          mData.tableRules.dataSearch.value[
                            'thong_tin_chung.giay_to.so_giay_to'
                          ]
                        "
                        clearable
                      ></el-input>
                    </el-form-item>
                  </b-col>
                  <b-col md="3">
                    <el-form-item
                      :label="aLang.sd_register_time"
                      prop="thoi_diem_tao"
                    >
                      <el-date-picker
                        type="date"
                        :format="aElement.datepicker.formatDate"
                        :valueFormat="aElement.datepicker.valueFormat"
                        v-model="
                          mData.tableRules.dataSearch.value.thoi_diem_tao
                        "
                        :placeholder="aElement.datepicker.placeholderDate"
                        clearable
                      ></el-date-picker>
                    </el-form-item>
                  </b-col>
                  <b-col :md="!aRole('SVHTT') && !aRole('PVHTT') ? '3' : '2'">
                    <el-form-item label="Điểm thanh toán">
                      <el-select
                        v-model="
                          mData.tableRules.dataSearch.value['merchant.enabled']
                        "
                        :placeholder="aLang.c_select"
                        clearable
                      >
                        <el-option
                          v-for="item in mData.dataDefault.listTrangThai"
                          :key="item.code"
                          :value="item.code"
                          :label="item.text"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </b-col>
                  <b-col md="2" v-if="!aRole('SVHTT') && !aRole('PVHTT')">
                    <el-form-item :label="aLang.sd_province">
                      <el-select
                        @change="changeProvince"
                        @clear="clearProvince"
                        v-model="
                          mData.tableRules.dataSearch.value[
                            'thong_tin_chung.dia_chi.tinh_id'
                          ]
                        "
                        :placeholder="aLang.c_select"
                        clearable
                      >
                        <el-option
                          v-for="item in mData.dataDefault.listProvince"
                          :key="item.id"
                          :value="item.id"
                          :label="item.name"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </b-col>
                  <b-col md="2">
                    <el-form-item :label="aLang.sd_commune">
                      <el-select
                        v-model="
                          mData.tableRules.dataSearch.value[
                            'thong_tin_chung.dia_chi.xa_id'
                          ]
                        "
                        :placeholder="aLang.c_select"
                        clearable
                      >
                        <el-option
                          v-for="item in mData.dataDefault.listCommune"
                          :key="item.id"
                          :value="item.id"
                          :label="item.name"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </b-col>
                  <b-col :md="!aRole('SVHTT') && !aRole('PVHTT') ? '3' : '2'">
                    <el-form-item label="Số điện thoại">
                      <el-input
                        v-model="
                          mData.tableRules.dataSearch.value[
                            'thong_tin_chung.nguoi_dai_dien.dien_thoai'
                          ]
                        "
                        clearable
                      ></el-input>
                    </el-form-item>
                  </b-col>
                  <b-col :md="!aRole('SVHTT') && !aRole('PVHTT') ? '3' : '2'">
                    <el-form-item label="Trạng thái hoạt động">
                      <el-select
                        v-model="
                          mData.tableRules.dataSearch.value[
                            'hoat_dong.ngung_hoat_dong'
                          ]
                        "
                        :placeholder="aLang.c_select"
                        clearable
                      >
                        <el-option
                          v-for="item in mData.dataDefault
                            .listTrangThaiHoatDong"
                          :key="item.code"
                          :value="item.code"
                          :label="item.text"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </b-col>
                </b-row>
                <el-form-item class="text-center mb-0">
                  <el-button
                    type="info"
                    native-type="submit"
                    v-ladda
                    plain
                    @click="fn_tableSearch()"
                    >{{ aLang.c_search }}</el-button
                  >
                </el-form-item>
              </el-form>
            </b-card>
          </b-collapse>
        </div>
        <b-row>
          <b-col md="8" class="p-0">
            <b-col md="4">
              <el-button
                v-if="!aRole('Officer') && !aRole('SVHTT') && !aRole('PVHTT')"
                @click="fn_handle('import')"
                type="warning"
                plain
                >{{ aLang.sd_enter_safe_destination_list }}</el-button
              >
            </b-col>
          </b-col>
          <b-col md="4">
            <div class="text-right mb-2">
              <el-button @click="fn_goToChuaLienKet()" type="primary" plain>
                <i class="fa fa-link"></i> Liên kết
              </el-button>
              <el-button @click="fn_tableShowFormSearch()" type="info" plain>{{
                aLang.c_showHideSearch
              }}</el-button>
            </div>
          </b-col>
        </b-row>
        <b-row v-if="mData.dataDefault.error">
          <b-col md="12" class="mb-2">
            <el-alert
              :title="mData.dataDefault.error"
              type="error"
              show-icon
            ></el-alert>
          </b-col>
        </b-row>

        <el-table
          :data="mData.tableRules.data"
          border
          @selection-change="fn_tableSelectionChange"
          @sort-change="fn_tableSortChange"
          max-height="484"
          style="width: 100%"
          :default-sort="{
            prop: mData.tableRules.defaultSort[0],
            order: mData.tableRules.defaultSort[1],
          }"
        >
          <el-table-column
            type="selection"
            width="40"
            v-if="mData.tableRules.allowSelect"
          ></el-table-column>

          <el-table-column
            prop="du_lieu_khai_bao.user_account"
            :label="aLang.sd_account_code"
            align="center"
            width="120"
          ></el-table-column>
          <el-table-column
            prop="thong_tin_chung.nguoi_dai_dien.dien_thoai"
            label="Số điện thoại"
            align="center"
            width="120"
            v-if="aRole('Admin,Officer,VNATAdmin')"
          >
            <template slot-scope="scope">
              <div class="text-center">
                {{
                  scope.row.thong_tin_chung.nguoi_dai_dien.dien_thoai
                    | numberFormat
                }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="thong_tin_chung.ten"
            :sortable="mData.tableRules.allowSorting"
            :label="aLang.sd_unit_name"
            min-width="180"
          ></el-table-column>
          <el-table-column
            prop="ten_loai_diem_den"
            :sortable="mData.tableRules.allowSorting"
            :label="aLang.sd_safe_destination_type"
            min-width="130"
          ></el-table-column>
          <el-table-column
            prop="tourist_incentives"
            :label="aLang.sd_tourist_incentives"
            min-width="130"
            align="center"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.haveMerchant">{{
                scope.row.tourist_incentives
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="tour_guide_incentives"
            :label="aLang.sd_tour_guide_incentives"
            min-width="130"
            align="center"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.haveMerchant">{{
                scope.row.tour_guide_incentives
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="thong_tin_chung.giay_to.so_giay_to"
            :sortable="mData.tableRules.allowSorting"
            :label="aLang.sd_tax_code"
            min-width="120"
          ></el-table-column>
          <el-table-column
            prop="thong_tin_chung.dia_chi.dia_chi"
            :sortable="mData.tableRules.allowSorting"
            :label="aLang.sd_address"
            min-width="180"
          ></el-table-column>
          <el-table-column
            prop="thoi_diem_tao"
            :sortable="mData.tableRules.allowSorting"
            :formatter="fn_formatterDatetime"
            :label="aLang.sd_register_time"
            width="160"
            align="center"
          ></el-table-column>
          <el-table-column :label="'Điểm thanh toán'" width="90" align="center">
            <template slot-scope="scope">
              <el-checkbox
                :disabled="scope.row.merchantDisable"
                v-model="scope.row.isMerchant"
                @change="
                  fn_changeTrangThaiDiemThanhToan(
                    scope.row.id,
                    scope.row.isMerchant
                  )
                "
              ></el-checkbox>
            </template>
          </el-table-column>
          <el-table-column label="Chứng thư số" width="90" align="center">
            <template slot-scope="scope">
              <el-checkbox
                :disabled="scope.row.disabledChungThucSo"
                v-model="scope.row.isChungThucSo"
                @change="
                  fn_changeTrangThaiChungThucSo(
                    scope.row.id,
                    scope.row.isChungThucSo
                  )
                "
              ></el-checkbox>
            </template>
          </el-table-column>
          <el-table-column
            label="Hợp đồng thanh toán thẻ"
            width="120"
            align="center"
          >
            <template slot-scope="scope">
              <el-checkbox
                :disabled="scope.row.disabledHopDongThanhToanThe"
                v-model="scope.row.isHopDongThanhToanThe"
                @change="
                  fn_changeTrangThaiHopDongThanhToanThe(
                    scope.row,
                    scope.row.isHopDongThanhToanThe
                  )
                "
              ></el-checkbox>
            </template>
          </el-table-column>
          <el-table-column
            label="Hợp đồng khách hàng thân thiết"
            width="120"
            align="center"
          >
            <template slot-scope="scope">
              <el-checkbox
                :disabled="scope.row.disabledHopDongKhachHangThanThiet"
                v-model="scope.row.isHopDongKhachHangThanThiet"
                @change="
                  fn_changeTrangThaiHopDongKhachHangThanThiet(
                    scope.row,
                    scope.row.isHopDongKhachHangThanThiet
                  )
                "
              ></el-checkbox>
            </template>
          </el-table-column>
          <el-table-column :label="aLang.c_action" align="center" width="120px">
            <template slot-scope="scope">
              <el-button
                size="mini"
                @click="fn_handle('detail', scope.$index, scope.row)"
                v-b-popover.hover.left="aLang.c_detail"
              >
                <i class="fa fa-eye"></i>
              </el-button>
              <el-button
                size="mini"
                @click="fn_handle('update', scope.$index, scope.row)"
                v-b-popover.hover.left="aLang.c_update"
              >
                <i class="icon-pencil icons"></i>
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <b-row class="mt-2" v-if="mData.tableRules.allowPaging">
          <div class="col-md-4">
            <el-button
              @click="fn_exportExcelMerchant()"
              type="primary"
              icon="el-icon-download"
              plain
            >
              Tải danh sách
            </el-button>
          </div>
          <div class="col-md-8 text-right">
            <el-pagination
              @size-change="fn_tableSizeChange"
              @current-change="fn_tableCurentChange"
              @prev-click="fn_tablePrevClick"
              @next-click="fn_tableNextClick"
              :page-sizes="mData.tableRules.lengthMenu"
              :page-size="mData.tableRules.limit"
              :current-page="mData.tableRules.page"
              background
              layout="total, sizes, prev, pager, next, jumper"
              :total="mData.tableRules.total"
              :pager-count="5"
            ></el-pagination>
          </div>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import DataService from "../../../service/DataService";
import MethodService from "../../../service/MethodService";
import ExtensionService from "../../../service/ExtensionService";
import DiemDenAnToanModel from "../DiemDenAnToan/DiemDenAnToanModel";
import mushroom from "../../../service/api/dulich-api";

export default {
  data() {
    return {
      title: "liên kết Ngân hàng SHB",
      aRole: MethodService.checkRole,
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      mData: {
        moduleName: "LienKetNganHangSHB", //requied
        urlImg: ExtensionService.urlImg,
        tableRules: MethodService.copyObject(DiemDenAnToanModel.tableRules),
        dataDefault: {
          roles: DataService.roles,
          listLoaiDDAT: DataService.loaiHinhRegister,
          listTrangThai: [
            {
              code: "true",
              text: "Là điểm thanh toán",
            },
            {
              code: "false",
              text: "Không là diểm thanh toán",
            },
          ],
          listTrangThaiHoatDong: DataService.trangThaiHoatDong,
          listProvince: [],
          listDistrict: [],
          listCommune: [],
          isDistrictDisabled: true,
          isCommuneDisabled: true,
          error: "",
          provinceManager: "",
          districtManager: "",
        },
        currentUser: JSON.parse(localStorage.getItem("currentUser")),
      },
    };
  },
  filters: {
    numberFormat: function (value) {
      if (!value) return "";
      if (value.length == 11) {
        return value.replace(/^\d{2}/, "0");
      }
      return value;
    },
  },
  methods: {
    //get list table
    async fn_initTable() {
      let dataFilter = {
        filters: this.mData.tableRules.filters,
      };
      if (this.mData.tableRules.allowPaging) {
        dataFilter.limit = this.mData.tableRules.limit;
        dataFilter.offset = this.mData.tableRules.offset;
      }
      if (this.mData.tableRules.allowSorting) {
        dataFilter.sort = this.mData.tableRules.sort;
      }
      if (this.mData.tableRules.showUrl) {
        this.$router
          .replace({
            name: "Admin-" + this.mData.moduleName + "-list",
            query: {
              limit: this.mData.tableRules.limit,
              page: this.mData.tableRules.page,
              sort: this.mData.tableRules.sort,
              filters: this.mData.tableRules.filters,
              showFormSearch: this.mData.tableRules.showFormSearch,
            },
          })
          .catch((err) => {});
      }
      let res = await mushroom.diem_den_an_toan.listAsync(dataFilter);
      this.mData.tableRules.data = this.changeData(res.result);
      this.mData.tableRules.total = res.meta.total;
      this.mData.tableRules.page = res.meta.offset / res.meta.limit + 1;
      if (
        this.mData.tableRules.offset == res.meta.total &&
        this.mData.tableRules.offset != 0
      ) {
        this.mData.tableRules.offset = 0;
        this.mData.tableRules.page = 1;
        this.fn_initTable();
      }
      console.log("this.mData.tableRules.data", this.mData.tableRules.data);
    },

    //xử lý dữ liệu đầu ra
    changeData(data) {
      data.forEach((item) => {
        let tenLoai = this.mData.dataDefault.listLoaiDDAT.find(
          (element) => element.code == item.loai_diem_den
        );
        if (tenLoai) {
          item.ten_loai_diem_den = tenLoai.text;
        } else {
          item.ten_loai_diem_den = "";
        }
        if (this.checkHaveMerchantKeyCode(item)) {
          console.log("item", item);
          item.isMerchant = item.merchant.enabled || false;
          item.merchantDisable = false;
        } else {
          item.merchantDisable = true;
        }
        if (!item.merchant || item.merchant.processingStatus == undefined) {
          item.processingStatusDisable = true;
        } else {
          item.processingStatus = item.merchant.processingStatus;
          item.processingStatusDisable = false;
        }

        item.haveMerchant = this.checkIsMerchant(item);

        // Ưu đãi
        item.tourist_incentives = undefined;
        item.tour_guide_incentives = undefined;

        if (
          item.thong_tin_chung.loai_hinh_uu_dai &&
          item.thong_tin_chung.gia_tri_uu_dai
        ) {
          item.tourist_incentives = `
            ${
              item.thong_tin_chung.gia_tri_uu_dai >= 1000
                ? item.thong_tin_chung.gia_tri_uu_dai.toLocaleString()
                : item.thong_tin_chung.gia_tri_uu_dai
            }
            ${
              item.thong_tin_chung.loai_hinh_uu_dai == "giam_gia_phan_tram"
                ? "%"
                : "đ"
            }
          `;
        }

        if (
          item.thong_tin_chung.huong_dan_vien &&
          item.thong_tin_chung.huong_dan_vien.uu_dai &&
          item.thong_tin_chung.huong_dan_vien.uu_dai.loai_hinh_uu_dai &&
          item.thong_tin_chung.huong_dan_vien.uu_dai.gia_tri_uu_dai
        ) {
          item.tour_guide_incentives = `
            ${item.thong_tin_chung.huong_dan_vien.uu_dai.gia_tri_uu_dai}
            ${
              item.thong_tin_chung.huong_dan_vien.uu_dai.loai_hinh_uu_dai ==
              "giam_gia_phan_tram"
                ? "%"
                : "đ"
            }
          `;
        }

        item.disabledChungThucSo = false;
        item.isChungThucSo = false;
        item.disabledHopDongThanhToanThe = false;
        item.isHopDongThanhToanThe = false;
        item.disabledHopDongKhachHangThanThiet = false;
        item.isHopDongKhachHangThanThiet = false;
        // Nếu không có merchant thì disable checkbox chứng thư số, hợp đồng thanh toán thẻ, hợp đồng khách hàng thân thiết
        if (!item.isMerchant) {
          item.disabledChungThucSo = true;
          item.disabledHopDongThanhToanThe = true;
          item.disabledHopDongKhachHangThanThiet = true;
          return;
        }
        if (!item.merchant || !this.checkHaveMerchantKeyCode(item)) {
          item.disabledChungThucSo = true;
          item.disabledHopDongThanhToanThe = true;
          item.disabledHopDongKhachHangThanThiet = true;
        } else {
          console.log('có merchant:', item)
          if (!item.merchant.signed || item.merchant.signed == "none") {
            item.isChungThucSo = false;
            item.disabledHopDongThanhToanThe = true;
            item.disabledHopDongKhachHangThanThiet = true;
          } else if (item.merchant.signed == "cert") {
            item.isChungThucSo = true;
            item.disabledHopDongKhachHangThanThiet = true;
          } else if (item.merchant.signed == "contact") {
            item.isChungThucSo = true;
            item.isHopDongThanhToanThe = true;
          }
          // Hợp đồng khách hàng thân thiết
          if (item.bankClient && item.bankClient.signed)
            item.isHopDongKhachHangThanThiet = item.bankClient.signed;
        }
      });
      return data;
    },

    checkHaveMerchantKeyCode(data) {
      return (
        data.merchant &&
        data.merchant.merchantCode &&
        data.merchant.clientCode &&
        data.merchant.secureKey
      );
    },

    checkIsMerchant(data) {
      return (
        data.merchant &&
        data.merchant.signed == "contact" &&
        data.bankClient &&
        data.bankClient.signed
      );
    },

    //click button
    fn_handle(type, scope, row) {
      if (type == "create") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-create",
        });
      }
      if (type == "update") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-update",
          params: { id: row.id },
        });
      }
      if (type == "detail") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-detail",
          params: { id: row.id },
        });
      }
    },

    //delete
    async fn_delete(id) {
      await mushroom.diem_den_an_toan.deleteOneAsync({ id: id });
      this.fn_initTable();
    },

    async fn_changeTrangThaiDiemThanhToan(id, status) {
      let data = {
        id: id,
        merchant: {
          enabled: status,
        },
      };
      try {
        await mushroom.diem_den_an_toan.updatePartiallyAsync(data);
        this.fn_initTable();
      } catch (error) {
        console.log("error", error);
      }
    },

    fn_tableSelectionChange(val) {
      var _this = this;
      this.mData.tableRules.recordSelected = [];
      val.forEach(function (element) {
        _this.mData.tableRules.recordSelected.push(element.id);
      });
    },

    fn_tableSortChange(column) {
      if (column.order == "ascending") {
        this.mData.tableRules.sort = column.prop;
      } else if (column.order == "descending") {
        this.mData.tableRules.sort = "-" + column.prop;
      } else {
        this.mData.tableRules.sort = "";
      }
      this.fn_initTable();
    },
    // search
    fn_tableSearch() {
      if (
        this.mData.tableRules.dataSearch.value["du_lieu_khai_bao.user_account"]
      ) {
        this.mData.tableRules.dataSearch.value[
          "du_lieu_khai_bao.user_account"
        ] =
          this.mData.tableRules.dataSearch.value[
            "du_lieu_khai_bao.user_account"
          ].trim();
      }
      if (this.mData.tableRules.dataSearch.value["thong_tin_chung.ten"]) {
        this.mData.tableRules.dataSearch.value["thong_tin_chung.ten"] =
          this.mData.tableRules.dataSearch.value["thong_tin_chung.ten"].trim();
      }
      if (
        this.mData.tableRules.dataSearch.value[
          "thong_tin_chung.giay_to.so_giay_to"
        ]
      ) {
        this.mData.tableRules.dataSearch.value[
          "thong_tin_chung.giay_to.so_giay_to"
        ] =
          this.mData.tableRules.dataSearch.value[
            "thong_tin_chung.giay_to.so_giay_to"
          ].trim();
      }
      if (
        this.mData.tableRules.dataSearch.value[
          "thong_tin_chung.nguoi_dai_dien.dien_thoai"
        ] &&
        this.mData.tableRules.dataSearch.value[
          "thong_tin_chung.nguoi_dai_dien.dien_thoai"
        ].substring(0, 1) == "0" &&
        this.mData.tableRules.dataSearch.value[
          "thong_tin_chung.nguoi_dai_dien.dien_thoai"
        ].length == 10
      ) {
        this.mData.tableRules.dataSearch.value[
          "thong_tin_chung.nguoi_dai_dien.dien_thoai"
        ] = this.mData.tableRules.dataSearch.value[
          "thong_tin_chung.nguoi_dai_dien.dien_thoai"
        ].replace(/^\d{1}/, "84");
      }

      this.$refs["myForm"].validate(async (valid) => {
        if (valid) {
          this.mData.tableRules.filters = MethodService.filterTable(
            JSON.stringify(this.mData.tableRules.dataSearch)
          );
          this.mData.tableRules.filters = this.mData.tableRules.filters.replace(
            "hoat_dong.ngung_hoat_dong=false",
            "hoat_dong.ngung_hoat_dong!=true"
          );
          this.mData.tableRules.filters = this.mData.tableRules.filters.replace(
            "merchant.enabled=false",
            "merchant.enabled!=true"
          );
          let m = this.mData.tableRules.filters.match(
            /thong_tin_chung.nguoi_dai_dien.dien_thoai(%3D|=)([^&|]*)/g
          );
          if (
            this.mData.tableRules.dataSearch.value[
              "thong_tin_chung.nguoi_dai_dien.dien_thoai"
            ] &&
            this.mData.tableRules.dataSearch.value[
              "thong_tin_chung.nguoi_dai_dien.dien_thoai"
            ].substr(0, 1) == "0" &&
            this.mData.tableRules.dataSearch.value[
              "thong_tin_chung.nguoi_dai_dien.dien_thoai"
            ].length == 10
          ) {
            if (m) {
              this.mData.tableRules.filters =
                this.mData.tableRules.filters.replace(
                  m[0],
                  m[0] +
                    "|thong_tin_chung.nguoi_dai_dien.dien_thoai=" +
                    this.mData.tableRules.dataSearch.value[
                      "thong_tin_chung.nguoi_dai_dien.dien_thoai"
                    ].replace(/^\d{1}/, "84")
                );
            }
          } else if (
            this.mData.tableRules.dataSearch.value[
              "thong_tin_chung.nguoi_dai_dien.dien_thoai"
            ] &&
            this.mData.tableRules.dataSearch.value[
              "thong_tin_chung.nguoi_dai_dien.dien_thoai"
            ].substr(0, 2) == "84" &&
            this.mData.tableRules.dataSearch.value[
              "thong_tin_chung.nguoi_dai_dien.dien_thoai"
            ].length == 11
          ) {
            if (m) {
              this.mData.tableRules.filters =
                this.mData.tableRules.filters.replace(
                  m[0],
                  m[0] +
                    "|thong_tin_chung.nguoi_dai_dien.dien_thoai=" +
                    this.mData.tableRules.dataSearch.value[
                      "thong_tin_chung.nguoi_dai_dien.dien_thoai"
                    ].replace(/^\d{2}/, "0")
                );
            }
          }

          this.mData.tableRules.offset = 0;
          this.fn_initTable();
          if (
            this.mData.tableRules.dataSearch.value[
              "thong_tin_chung.nguoi_dai_dien.dien_thoai"
            ] &&
            this.mData.tableRules.dataSearch.value[
              "thong_tin_chung.nguoi_dai_dien.dien_thoai"
            ].substring(0, 2) == "84" &&
            this.mData.tableRules.dataSearch.value[
              "thong_tin_chung.nguoi_dai_dien.dien_thoai"
            ].length == 11
          ) {
            this.mData.tableRules.dataSearch.value[
              "thong_tin_chung.nguoi_dai_dien.dien_thoai"
            ] = this.mData.tableRules.dataSearch.value[
              "thong_tin_chung.nguoi_dai_dien.dien_thoai"
            ].replace(/^\d{2}/, "0");
          }
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },
    fn_defaultSearch() {
      this.mData.tableRules.filters = MethodService.filterTable(
        JSON.stringify(this.mData.tableRules.dataSearch)
      );
      this.mData.tableRules.filters = this.mData.tableRules.filters.replace(
        "hoat_dong.ngung_hoat_dong=false",
        "hoat_dong.ngung_hoat_dong!=true"
      );
      this.mData.tableRules.filters = this.mData.tableRules.filters.replace(
        "merchant.enabled=false",
        "merchant.enabled!=true"
      );

      this.mData.tableRules.offset = 0;

      this.fn_initTable();
    },

    //event table
    fn_tableSizeChange(limit) {
      this.mData.tableRules.limit = limit;
      this.fn_tableChangeOffset(this.mData.tableRules.page);
    },
    fn_tableCurentChange(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tablePrevClick(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tableNextClick(page) {
      this.fn_tableChangeOffset(page);
    },

    fn_tableChangeOffset(page) {
      this.mData.tableRules.page = page;
      this.mData.tableRules.offset =
        (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      this.fn_initTable();
    },

    fn_tableShowFormSearch() {
      this.mData.tableRules.showFormSearch =
        !this.mData.tableRules.showFormSearch;
      let query = Object.assign({}, this.$route.query);
      query.showFormSearch = this.mData.tableRules.showFormSearch;
      this.$router.push({
        name: "Admin-" + this.mData.moduleName + "-list",
        query: query,
      });
    },

    // Chuyển sang màn tìm kiếm tài khoản chưa liên kết SHB
    fn_goToChuaLienKet() {
      this.$router.push({
        name: "Admin-" + this.mData.moduleName + "-chualienket",
      });
    },

    fn_formatterDate(row, column, cellValue) {
      return MethodService.formatDate(cellValue, "date");
    },

    fn_formatterDatetime(row, column, cellValue) {
      return MethodService.formatDate(cellValue, "datetime");
    },

    async fn_initDataDefault() {},

    fn_hashUrl() {
      if (this.$route.query.limit) {
        this.mData.tableRules.limit = parseInt(this.$route.query.limit);
      }
      if (this.$route.query.page) {
        this.mData.tableRules.page = parseInt(this.$route.query.page);
      }
      if (this.$route.query.limit && this.$route.query.page) {
        this.mData.tableRules.offset =
          (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      }
      if (this.$route.query.sort) {
        this.mData.tableRules.sort = this.$route.query.sort;
        this.mData.tableRules.defaultSort[0] = this.mData.tableRules.sort;
        if (this.mData.tableRules.sort.indexOf("-") != -1) {
          this.mData.tableRules.defaultSort[1] = "descending";
        } else {
          this.mData.tableRules.defaultSort[1] = "ascending";
        }
      }

      if (this.$route.query.filters) {
        this.mData.tableRules.filters = this.$route.query.filters;
        // string to object
        this.mData.tableRules.filters = this.mData.tableRules.filters.replace(
          "hoat_dong.ngung_hoat_dong!=true",
          "hoat_dong.ngung_hoat_dong=false"
        );
        this.mData.tableRules.filters = this.mData.tableRules.filters.replace(
          "merchant.enabled!=true",
          "merchant.enabled=false"
        );
        let a = decodeURIComponent(this.mData.tableRules.filters);
        let m = a.match(/thong_tin_chung.nguoi_dai_dien.dien_thoai=([^&\|]*)/g);
        if (m) {
          this.mData.tableRules.filters = this.mData.tableRules.filters.replace(
            "|" + m[1],
            ""
          );
        }
        this.mData.tableRules.dataSearch.value = MethodService.stringToObject(
          this.mData.tableRules.filters
        );
        let m1 = this.mData.tableRules.filters.match(/\$vn_text=([^&]*)(&|$)/);
        if (m1) {
          this.$set(
            this.mData.tableRules.dataSearch.value,
            "thong_tin_chung.ten",
            decodeURIComponent(m1[1])
          );
        }
        if (
          this.mData.tableRules.dataSearch.value[
            "thong_tin_chung.nguoi_dai_dien.dien_thoai"
          ] &&
          this.mData.tableRules.dataSearch.value[
            "thong_tin_chung.nguoi_dai_dien.dien_thoai"
          ].substring(0, 2) == "84" &&
          this.mData.tableRules.dataSearch.value[
            "thong_tin_chung.nguoi_dai_dien.dien_thoai"
          ].length == 11
        ) {
          this.mData.tableRules.dataSearch.value[
            "thong_tin_chung.nguoi_dai_dien.dien_thoai"
          ] = this.mData.tableRules.dataSearch.value[
            "thong_tin_chung.nguoi_dai_dien.dien_thoai"
          ].replace(/^\d{2}/, "0");
        }
      }
      if (this.$route.query.showFormSearch == "true") {
        this.mData.tableRules.showFormSearch = true;
      }
      if (this.$route.query.showFormSearch == "false") {
        this.mData.tableRules.showFormSearch = false;
      }
    },

    changeProvince(province, clear = true) {
      this.getCommuneList(province);
      this.mData.dataDefault.listCommune = [];
      this.mData.dataDefault.isDistrictDisabled = false;
      this.mData.dataDefault.isCommuneDisabled = true;
      if (clear) {
        this.mData.tableRules.dataSearch.value[
          "thong_tin_chung.dia_chi.xa_id"
        ] = null;
      }
    },

    clearProvince() {
      this.mData.dataDefault.listDistrict = [];
      this.mData.dataDefault.listCommune = [];
      this.mData.tableRules.dataSearch.value["thong_tin_chung.dia_chi.xa_id"] =
        null;
    },

    clearDistrict() {
      this.mData.dataDefault.listCommune = [];
      this.mData.tableRules.dataSearch.value["thong_tin_chung.dia_chi.xa_id"] =
        null;
    },

    async getProvinceList() {
      let province = await mushroom.province.getAllAsync();
      if (province.result.length > 0) {
        this.mData.dataDefault.listProvince = province.result;
      }
    },

    async getCommuneList(provinceId) {
      let commune = await mushroom.commune.getAllAsync({
        filters: [`provinceId=${provinceId}`],
      });
      if (commune.result.length > 0) {
        this.mData.dataDefault.listCommune = commune.result;
      }
    },
    fn_exportExcelMerchant() {
      MethodService.exportExcelMerchant(this.mData.tableRules.data);
    },

    /**
     * Thay đổi trạng thái hợp đồng chứng thực số
     * @param {*} id
     * @param {*} statusChungThucSo
     */
    fn_changeTrangThaiChungThucSo(id, statusChungThucSo) {
      let data = {
        id: id,
        merchant: {
          signed: !statusChungThucSo ? "none" : "cert",
        },
      };
      console.log("data fn_changeTrangThaiChungThucSo", data);
      this.callApiUpdate(data);
    },

    /**
     * Thay đổi trạng thái hợp đồng thanh toán thẻ
     * @param {*} dataRow
     * @param {*} statusHopDongThanhToanThe
     */
    fn_changeTrangThaiHopDongThanhToanThe(dataRow, statusHopDongThanhToanThe) {
      let data = {
        id: dataRow.id,
        merchant: {
          signed: !statusHopDongThanhToanThe ? "cert" : "contact",
        },
      };
      console.log("data fn_changeTrangThaiHopDongThanhToanThe", data);
      this.callApiUpdate(data);
    },

    /**
     * Thay đổi trạng thái hợp đồng khách hàng thân thiết
     * @param {*} dataRow
     * @param {*} statusHopDongKhachHangThanThiet
     */
    fn_changeTrangThaiHopDongKhachHangThanThiet(
      dataRow,
      statusHopDongKhachHangThanThiet
    ) {
      let data = {
        id: dataRow.id,
        thong_tin_chung: {
          loai_hinh_uu_dai: "",
          gia_tri_uu_dai: "",
          huong_dan_vien: {
            uu_dai: {
              loai_hinh_uu_dai: "",
              gia_tri_uu_dai: "",
            },
          },
        },
        bankClient: {
          signed: statusHopDongKhachHangThanThiet,
        },
      };
      let dataUuDai = {
        id: dataRow.id,
        loai_hinh_uu_dai: null,
        gia_tri_uu_dai: null,
        loai_hinh_uu_dai_hdv: null,
        gia_tri_uu_dai_hdv: null,
      };
      console.log("data fn_changeTrangThaiHopDongKhachHangThanThiet", data);
      this.callApiUpdate(
        data,
        !statusHopDongKhachHangThanThiet ? "KHTT" : "",
        dataUuDai
      );
    },

    /**
     * Gọi api update trạng thái
     * @param {*} data
     */
    async callApiUpdate(data, type, dataUuDai) {
      try {
        await mushroom.diem_den_an_toan.updatePartiallyAsync(data);
        if (type == "KHTT")
          await mushroom.diem_den_an_toan.update_uu_daiAsync({
            body: dataUuDai,
          });
        this.fn_initTable();
      } catch (error) {
        console.log("error", error);
      }
    },
  },

  //run after render view
  created() {
    this.fn_hashUrl();
    this.getProvinceList();
    this.fn_defaultSearch();
  },
  mounted() {
    if (
      this.mData.tableRules.dataSearch.value["thong_tin_chung.dia_chi.tinh_id"]
    ) {
      this.changeProvince(
        this.mData.tableRules.dataSearch.value[
          "thong_tin_chung.dia_chi.tinh_id"
        ],
        false
      );
    }
  },
};
</script>
